export default "__VITE_ASSET__BYwMh8X5__"